import { COLORS } from '../../constants';

const getColor = colorLevel => {
  switch (colorLevel) {
    case 'primary':
    default:
      return COLORS.GREEN;
  }
};

// eslint-disable-next-line no-unused-vars
const styles = theme => ({
  root: {
    borderStyle: 'solid',
    borderWidth: '2px',
    borderColor: props => getColor(props.color),
    borderRadius: 4,
    textTransform: 'capitalize',
    boxShadow: 'none',
    padding: '5px 16px',
    fontWeight: 400,
    width: props => (props.fullWidth ? '100%' : 'auto'),

    '&:hover': {
      borderWidth: 2,
    },
  },
});

export default styles;
